window.WatchlistApp = window.WatchlistApp || {};

window.WatchlistApp.Popup = (function () {
    let notificationTimer = null;

    function _openManual(id) {
        const el = document.querySelector(`#${id}`);
        if (el) {
            el.setAttribute('visible', true);
            el.setAttribute('scale', '1 1 1');
            
            const component = el.components[id] || 
                            el.components['add-unit-vr-popup'] || 
                            el.components['add-to-watchlist-vr-popup'] || 
                            el.components['watchlist-input-popup'] || 
                            el.components['watchlist-confirmation-popup'] ||
                            el.components['watchlist-notification-popup'];
            
            if (component && typeof component.open === 'function') {
                component.open();
            }
        }
    }

    function _closeManual(id) {
        if (id === 'add-to-watchlist-vr-popup' && window.PopupManager) {
            window.PopupManager.close(id);
            return;
        }

        const el = document.querySelector(`#${id}`);
        if (el) {
            el.setAttribute('visible', false);
            el.setAttribute('scale', '0 0 0');
            const component = el.components[id] || el.components['add-unit-vr-popup'] || el.components['add-to-watchlist-vr-popup'] || el.components['watchlist-input-popup'] || el.components['watchlist-confirmation-popup'] || el.components['watchlist-notification-popup'];
            if (component && typeof component.close === 'function') {
                component.close();
            }
        }
    }

    function showAddUnitPopup(options = {}) {
        const el = document.querySelector('#add-unit-vr-popup');
        if (el && el.components['add-unit-vr-popup']) {
            if (el.components['add-unit-vr-popup'].setOptions) {
                el.components['add-unit-vr-popup'].setOptions(options);
            }
        }
        _openManual('add-unit-vr-popup');
    }

    function showAddToWatchlistPopup(ticker, companyName) {
        const id = 'add-to-watchlist-vr-popup';
        const el = document.querySelector(`#${id}`);
        if (el && el.components[id]) {
            el.components[id].setup(ticker, companyName);
            if (window.PopupManager) {
                window.PopupManager.open(id);
            } else {
                _openManual(id);
            }
        }
    }

    function showInputPopup(title, initialValue, placeholder, confirmText, onConfirm, validationOptions = {}) {
        const popupEl = document.querySelector('#watchlist-input-vr-popup');
        if (popupEl && popupEl.components['watchlist-input-popup']) {
            popupEl.components['watchlist-input-popup'].setup({
                title, initialValue, placeholder, confirmText, onConfirm, validationOptions
            });
            _openManual('watchlist-input-vr-popup');
        }
    }

    function showNotificationPopup(title, message, buttonText = 'OK') {
        const id = 'watchlist-notification-vr-popup';
        const popupEl = document.querySelector(`#${id}`);
        if (popupEl && popupEl.components['watchlist-notification-popup']) {
            if (notificationTimer) {
                clearTimeout(notificationTimer);
                notificationTimer = null;
            }

            let processedMessage = message
                .replace(/<br\s*\/?>/gi, '\n')
                .replace(/<b>/gi, '')
                .replace(/<\/b>/gi, '');

            popupEl.components['watchlist-notification-popup'].setup({
                title: title,
                content: processedMessage,
                buttonText: buttonText
            });

            popupEl.setAttribute('position', '0 2.65 -0.8');

            _openManual(id);

            notificationTimer = setTimeout(() => {
                _closeManual(id);
                notificationTimer = null;
            }, 2000);
        }
    }

    function showConfirmationPopup(title, message, leftBtnText, leftBtnAction, rightBtnText = 'Cancel', rightBtnAction = null) {
        const popupEl = document.querySelector('#watchlist-confirmation-vr-popup');
        if (popupEl && popupEl.components['watchlist-confirmation-popup']) {
            popupEl.components['watchlist-confirmation-popup'].setup({
                title, message, leftBtnText, leftBtnAction, rightBtnText, rightBtnAction
            });
            _openManual('watchlist-confirmation-vr-popup');
        }
    }

    function showPremiumLockPopup() {
        if (showConfirmationPopup) {
            showConfirmationPopup(
                'Multiple Watchlists are coming soon!',
                'Organizing assets into different portfolios is a Pro feature currently in development.',
                null, 
                null,
                'Cancel',
                () => { _closeManual('watchlist-confirmation-vr-popup'); }
            );
        }
    }

    function showPremiumLimitPopup(title, message) {
        const defaultTitle = "Multiple Watchlists are coming soon!";
        const defaultMessage = "Organizing assets into different portfolios is a Pro feature currently in development.";

        if (showConfirmationPopup) {
            showConfirmationPopup(
                title || defaultTitle,
                message || defaultMessage,
                null,
                null,
                'Cancel',
                () => { _closeManual('watchlist-confirmation-vr-popup'); }
            );
        }
    }

    return {
        showAddUnitPopup,
        showAddToWatchlistPopup,
        showInputPopup,
        showNotificationPopup,
        showConfirmationPopup,
        showPremiumLockPopup,
        showPremiumLimitPopup,
        showEditHoldingsPopup: function(config) {
            const id = 'edit-holdings-vr-popup';
            const popupEl = document.querySelector(`#${id}`);
            if (popupEl && popupEl.components[id]) {
                popupEl.components[id].setup(config);
                _openManual(id);
            }
        },
        closeManual: _closeManual
    };
})();
